var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProcessing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clock-fast-forward"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 2C3.79086 2 2 3.79086 2 6C2 8.20914 3.79086 10 6 10C7.25635 10 8.37719 9.42137 9.11132 8.51414C9.28502 8.29948 9.59986 8.26628 9.81452 8.43998C10.0292 8.61369 10.0624 8.92853 9.88868 9.14319C8.97285 10.275 7.57091 11 6 11C3.23858 11 1 8.76142 1 6C1 3.23858 3.23858 1 6 1C8.56714 1 10.6824 2.93467 10.9674 5.42552L10.9964 5.3965C11.1916 5.20121 11.5082 5.20116 11.7035 5.39639C11.8988 5.59163 11.8988 5.90821 11.7036 6.1035L10.7039 7.1035C10.6101 7.19728 10.483 7.24998 10.3503 7.25C10.2177 7.25002 10.0906 7.19736 9.99677 7.10361L8.99647 6.10361C8.80118 5.90837 8.80114 5.59179 8.99637 5.3965C9.1916 5.20121 9.50819 5.20116 9.70348 5.39639L9.9874 5.68024C9.8245 3.6206 8.10151 2 6 2ZM6 3C6.27614 3 6.5 3.22386 6.5 3.5V5.73241L7.77735 6.58397C8.00711 6.73715 8.0692 7.04759 7.91603 7.27735C7.76285 7.50711 7.45241 7.5692 7.22265 7.41603L5.72265 6.41603C5.58355 6.32329 5.5 6.16718 5.5 6V3.5C5.5 3.22386 5.72386 3 6 3Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessing);
export default __webpack_public_path__ + "static/media/processing.8847811508ca765ee5bc7c6460fcabb4.svg";
export { ForwardRef as ReactComponent };